import React, { useState } from 'react';

const animation = {
	transition: "opacity 0.3s ease-in"
}

export const SmoothImage = function ({ style, ...rest}) {
	const [loaded, setLoader] = useState(0)
	const injectedStyle = { ...style, ...animation, opacity: loaded}
	return (
	<img style={injectedStyle} {...rest}
			 onLoad={()=> setLoader(1)}/>
	);
}
